export default {
  // Hero
  heroTag: "East Africa · Rwanda · FDI",
  heroTitle1: "Your Gateway to",
  heroTitle2: "East Africa's",
  heroTitle3: "Fastest-Growing",
  heroTitle4: "Markets",
  heroSubtitle: "Your trusted partner for investment, compliance & business facilitation across East Africa",
  heroCta1: "Start Your Company",
  heroCta2: "Explore Opportunities",
  heroCta3: "Get Tender Support",
  heroStat1: "Companies Registered",
  heroStat2: "East African Markets",
  heroStat3: "Compliance Rate",
  heroStat4: "Years Experience",
  heroScroll: "Scroll",

  // What We Do
  whatWeDoTag: "Our Expertise",
  whatWeDoTitle: "What We",
  whatWeDoTitleAccent: "Do",
  whatWeDoDesc: "AIP provides end-to-end support for businesses entering or expanding in East Africa — from legal formation to market growth.",
  pillar1Title: "Company Registration & Compliance",
  pillar1Desc: "End-to-end incorporation support for foreign companies in Rwanda and East Africa, with full regulatory compliance management.",
  pillar2Title: "Investment Facilitation",
  pillar2Desc: "Connecting international investors with high-growth opportunities across East Africa's most dynamic sectors.",
  pillar3Title: "Business Opportunities",
  pillar3Desc: "Curated investment and partnership opportunities across Rwanda and East Africa, matched to your sector and goals.",
  pillar4Title: "Tender Support Services",
  pillar4Desc: "Comprehensive bid preparation, document acquisition, securities, and representation for public and private tenders.",

  // Featured Opportunities
  opportunitiesTag: "Live Opportunities",
  opportunitiesTitle: "Current Investment",
  opportunitiesTitleAccent: "Opportunities",
  opportunitiesDesc: "Hand-picked, verified investment opportunities across Rwanda and East Africa's most dynamic sectors.",
  oppStatus: "Open",
  oppExpressInterest: "Express Interest",

  // Regulated Sectors
  sectorsTag: "Specialized Expertise",
  sectorsTitle1: "Regulated",
  sectorsTitle2: "Sectors We Serve",
  sectorsDesc: "Specialized compliance support across East Africa's highest-growth industries — licensing, certifications & permits handled.",
  sectorsQuote: "AIP combines deep regulatory knowledge, a powerful local network, and a hands-on approach to ensure your business succeeds.",
  sectorHealth: "Health Services",
  sectorHealthDesc: "Medicines, medical devices, health facilities",
  sectorHealthDetail: "Hospitals, clinics and other health facilities work permits/license; human medicines retailers license acquisition; human medicines wholesaler license acquisition; human medical devices supplier license acquisition; medicines registration; medical devices registration; medical products & devices importation license acquisition; medical products & devices exportation license acquisition",
  showMore: "Show more",
  showLess: "Show less",
  close: "Close",
  sectorInfrastructure: "Infrastructure",
  sectorInfrastructureDesc: "Roads, energy, utilities, public works",
  sectorManufacturing: "Manufacturing",
  sectorManufacturingDesc: "Factories, import/export licensing",
  sectorRealEstate: "Real Estate & Construction",
  sectorRealEstateDesc: "Property development, permits, licensing",
  sectorMining: "Mining",
  sectorMiningDesc: "Minerals, extraction, processing",
  sectorTourism: "Tourism",
  sectorTourismDesc: "Hospitality, travel, tourism licensing",
  sectorAgribusiness: "Agribusiness",
  sectorAgribusinessDesc: "Food production, processing, export",
  sectorEducation: "Education",
  sectorEducationDesc: "Schools, universities, EdTech platforms",
  sectorFinance: "Financial Services",
  sectorFinanceDesc: "Banking, insurance, fintech licensing",
  sectorFood: "Food & Beverages",
  sectorFoodDesc: "Food safety, certifications, permits",
  badgeLicensed: "Licensed",
  badgeCompliant: "Compliant",
  badgeTrusted: "Trusted",

  // Why Choose AIP
  whyChooseTag: "Why Choose AIP",
  whyChooseTitle1: "Your Gateway to",
  whyChooseTitle2: "East Africa's",
  whyChooseTitle3: "Fastest-Growing",
  whyChooseTitle4: "Markets",
  whyChooseDesc: "AIP combines deep regulatory knowledge, a powerful local network, and a hands-on approach to ensure your business succeeds in Rwanda and across East Africa. We navigate complexity so you don't have to.",
  tagLocal: "Local Expertise",
  tagSpeed: "Speed & Efficiency",
  tagFull: "Full Compliance",
  tagNetwork: "Trusted Network",
  whyCta: "Learn About Us",

  // Sector Support Form
  sectorFormTitle: "Request Sector Support",
  sectorFormSubtitle: "Tell us what support you need in this sector and our specialists will reach out within 24 hours.",
  sectorFormSectorLabel: "Sector",
  sectorFormSuccessTitle: "Request Submitted!",
  sectorFormSuccessBody: "Our sector specialists will get back to you within 24 hours.",
  sectorFormSubmit: "Submit Request",

  // CTA
  ctaTag: "Get Started Today",
  ctaTitle: "Ready to enter East Africa's fastest-growing markets?",
  ctaDesc: "From company registration to tender participation — AIP is your end-to-end partner for success in Rwanda and across East Africa.",
  ctaBtn1: "Contact AIP Today",
  ctaBtn2: "Explore Services",
};